import { render, staticRenderFns } from "./uploadDocs.vue?vue&type=template&id=d1a527f6&"
import script from "./uploadDocs.vue?vue&type=script&lang=js&"
export * from "./uploadDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports